import { Injectable } from '@angular/core';
import { Context, Data, DnnAppComponent } from '@2sic.com/dnn-sxc-angular';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class NewsletterApi {
  constructor(
      private data: Data,
  ) {
  }

  subscriberExists(email : string) {
    return this.data.api('Newsletter').get('SubscriberExists', new HttpParams().set('mail', email));
  }

  getCategories() {
    return this.data.content<Category>('Categories').get();
  }

  newSubscriber(subscriber: Subscriber) {
    return this.data.api('Newsletter').post('NewSubscriber', subscriber);
  }

  sendLink(email: string) {
    return this.data.api('Newsletter').post('SendLink', { email: email });
  }

  updateSubscriber(updateSubscriber: UpdateSubscriber) {
    return this.data.api('Newsletter').post('UpdateSubscriber', updateSubscriber);
  }

  getSubscriber(updateSubscriber: UpdateSubscriber) {
    return this.data.api<UpdateSubscriber>('Newsletter')
      .post('GetSubscriber', updateSubscriber)
      .pipe(map(c => Object.assign(new UpdateSubscriber(c.email, c.categories), c)));
  }
}

export class Category {
  Name: string;
  Selected: boolean;
  Id: number;
  SharepointId: number;
  GroupName: string;
  SortOrder:number;
}

export class Subscriber {
  constructor(email: string, categories: number[]) {
    this.email = email;
    this.categories = categories;
    this.subscriberLanguage = (<any>window).bsvNewsletterDefaultLanguage;
  }
  email: string;
  subscriberLanguage: string;
  categories: number[];
  hasCategory(id: number) {
    return this.categories.some(c => c == id);
  }
  toggleCategory(id: number) {
    this.setCategory(id, !this.hasCategory(id))
  }
  setCategory(id: number, state: boolean) {
    if(state === false && this.hasCategory(id))
      this.categories.splice(this.categories.indexOf(id), 1);
    else if(state === true && !this.hasCategory(id))
      this.categories.push(id);
  }
}

export class UpdateSubscriber extends Subscriber {
  hash: string;
  validUntil: string;
  id: number;
}